export default "__VITE_ASSET__CAfAOqoh__"